// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3K7sz","amount":"Amount_amount__3SIV6","tip":"Amount_tip__2eBNs","tipHeader":"Amount_tipHeader__2ZyLm","tipsWrap":"Amount_tipsWrap__2B5z-"};